import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        ticket: require("@/views/ticket/store").default,
        auth: require("@/lib/auth/store").default,
        zhiji: require("@/views/zhiji/js/modules/index.js").default,
        im: require("@/views/agent_im/store").default,
        statement: require("@/views/statement/store").default
    }
});
